import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, Text } from '../../../../../components';

const StyledText = styled(Text)`
  font-size: 16px;
  font-weight: 700;
`;

const DifferenceIndicator = ({
  isPositive,
  difference,
  percentageChange,
  symbol,
  isSymbolPrefix
}) => {
  if (difference === 0) {
    return <StyledText $color='var(--content-subtitle)'>No change from prior period</StyledText>;
  }

  const formatDifference = (value) => {
    const absValue = Math.abs(value).toLocaleString();
    return isSymbolPrefix ? `${symbol ?? ''}${absValue}` : `${absValue}${symbol ?? ''}`;
  };

  const iconColor = isPositive ? 'var(--success-default)' : 'var(--critical-default)';
  const iconName = isPositive ? 'caret-up' : 'caret-down';

  return (
    <>
      <Icon name={iconName} size={24} displaySize={16} color={iconColor} />
      <StyledText $color={iconColor}>{formatDifference(difference)}</StyledText>
      <StyledText $color={iconColor}>
        {percentageChange && ` (${isPositive ? '+' : '-'}${percentageChange}%)`}
      </StyledText>
    </>
  );
};

DifferenceIndicator.propTypes = {
  isPositive: PropTypes.bool.isRequired,
  difference: PropTypes.number.isRequired,
  percentageChange: PropTypes.string,
  symbol: PropTypes.string.isRequired,
  isSymbolPrefix: PropTypes.bool.isRequired
};

export { DifferenceIndicator };
